import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Card surface. Default size matches the prototype's `.card` (radius-lg,
 * 1.25rem 1.5rem padding). `size="xl"` matches the prototype's `.auth-card`.
 */
export function Card({ size = 'md', className, children, ...rest }) {
    const classes = ['kb-card', size === 'xl' && 'kb-card--xl', className].filter(Boolean).join(' ');
    return (_jsx("div", { className: classes, ...rest, children: children }));
}
export function CardTitle({ children, className, ...rest }) {
    return (_jsx("h3", { className: ['kb-card-title', className].filter(Boolean).join(' '), ...rest, children: children }));
}
export function CardSubtitle({ children, className, ...rest }) {
    return (_jsx("p", { className: ['kb-card-subtitle', className].filter(Boolean).join(' '), ...rest, children: children }));
}
//# sourceMappingURL=Card.js.map